import {PdsWidget} from './pds-widget';
export class PdsCopyrightClause extends PdsWidget {

  is = 'pds-copyright-clause';
  scopeClass: string;

}
